import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component(async (node) => {
  const menuCloseBtn = node.querySelector<HTMLElement>('[data-menu-close-btn]');
  const megamenus = node.querySelectorAll<HTMLElement>('[data-megamenu]');
  const megamenuBtns = node.querySelectorAll<HTMLElement>('[data-megamenu-btn]');

  const initMenuDrawer = () => {
    const menuDrawer = Drawer(node);

    menuDrawer.on('open', () => {
      document.documentElement.style.overflow = 'hidden';
    });

    menuDrawer.on('close', () => {
      document.documentElement.style.overflow = '';
    });

    document.addEventListener('mobileMenu:open', () => {
      menuDrawer.open();
    });

    menuCloseBtn.addEventListener('click', () => {
      menuDrawer.close();
    });
  };

  const initMegamenus = () => {
    megamenus.forEach((megamenu) => {
      const { index } = megamenu.dataset;
      const megamenuBtn = Array.from(megamenuBtns).find((btn) => btn.dataset.index === index);
      const megamenuBackBtn = megamenu.querySelector('[data-megamenu-back-btn]');
      const megamenuCloseBtn = megamenu.querySelector('[data-megamenu-close-btn]');

      megamenuBtn.addEventListener('click', () => {
        megamenu.hidden = false;
      });

      megamenuBackBtn.addEventListener('click', () => {
        megamenu.hidden = true;
      });

      megamenuCloseBtn.addEventListener('click', () => {
        menuCloseBtn.click();

        node.addEventListener('transitionend', () => {
          megamenu.hidden = true;
        }, { once: true });
      });
    });
  };

  const init = () => {
    initMenuDrawer();
    initMegamenus();
  };

  init();
});
